import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Booking, FilterState } from '../../core/models';

@Injectable({
  providedIn: 'root',
})
export class DashboardFilterService {
  private readonly _filters$ = new BehaviorSubject<FilterState>({
    selectedCompanies: [],
    selectedShip: '',
    savedDate: null,
    loadedBookings: [],
    searchTerm: '',
    showEmpty: true,
  });

  readonly filters$: Observable<FilterState> = this._filters$.asObservable();

  setFilters(state: FilterState) {
    this._filters$.next({ ...state });
  }

  updateCompanies(companies: string[]) {
    const cw = this._filters$.value.savedDate;
    const ship = this._filters$.value.selectedShip;
    const lB = this._filters$.value.loadedBookings;
    const sT = this._filters$.value.searchTerm;
    const sE = this._filters$.value.showEmpty;
    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship || '',
      savedDate: cw ?? null,
      loadedBookings: lB || [],
      searchTerm: sT || '',
      showEmpty: sE ?? true,
    };

    // console.log('update Company ', nextState);

    this._filters$.next(nextState);
  }
  updateVisibility(visiblity: boolean) {
    const cw = this._filters$.value.savedDate;
    const companies = this._filters$.value.selectedCompanies;
    const ship = this._filters$.value.selectedShip;
    const lB = this._filters$.value.loadedBookings;
    const sT = this._filters$.value.searchTerm;
    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship || '',
      savedDate: cw ?? null,
      loadedBookings: lB || [],
      searchTerm: sT || '',
      showEmpty: visiblity,
    };

    // console.log('update Companies ', nextState);
    this._filters$.next(nextState);
  }

  updateShip(ship: string) {
    // console.log('oldstate', this._filters$.value);
    const cw = this._filters$.value.savedDate;
    const companies = this._filters$.value.selectedCompanies;
    const lB = this._filters$.value.loadedBookings;
    const sT = this._filters$.value.searchTerm;
    const sE = this._filters$.value.showEmpty;
    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship,
      savedDate: cw ?? null,
      loadedBookings: lB || [],
      searchTerm: sT || '',
      showEmpty: sE ?? true,
    };
    //console.log('update Ship ', nextState);

    this._filters$.next(nextState);
  }

  updateCalendarWeek(savedDate: string | null) {
    const companies = this._filters$.value.selectedCompanies;
    const ship = this._filters$.value.selectedShip;
    const lB = this._filters$.value.loadedBookings;
    const sT = this._filters$.value.searchTerm;
    const sE = this._filters$.value.showEmpty;

    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship,
      savedDate: savedDate ?? null,
      loadedBookings: lB || [],
      searchTerm: sT || '',
      showEmpty: sE ?? true,
    };
    //  console.log('UpdateCW ', nextState);
    this._filters$.next(nextState);
  }
  updateloadedBookings(bookings: Booking[]) {
    const companies = this._filters$.value.selectedCompanies;
    const ship = this._filters$.value.selectedShip;
    const cw = this._filters$.value.savedDate;
    const sT = this._filters$.value.searchTerm;
    const sE = this._filters$.value.showEmpty;

    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship,
      savedDate: cw ?? null,
      loadedBookings: bookings || [],
      searchTerm: sT || '',
      showEmpty: sE ?? true,
    };
    //  console.log('UpdateCW ', nextState);
    this._filters$.next(nextState);
  }

  updateSearchTerm(searchString: string) {
    const companies = this._filters$.value.selectedCompanies;
    const ship = this._filters$.value.selectedShip;
    const cw = this._filters$.value.savedDate;
    const lB = this._filters$.value.loadedBookings;
    const sE = this._filters$.value.showEmpty;
    const nextState: FilterState = {
      selectedCompanies: companies ?? [],
      selectedShip: ship,
      savedDate: cw ?? null,
      loadedBookings: lB || [],
      searchTerm: searchString || '',
      showEmpty: sE ?? true,
    };
    //  console.log('UpdateCW ', nextState);
    this._filters$.next(nextState);
  }

  resetFilters() {
    const nextState: FilterState = {
      selectedCompanies: [],
      selectedShip: '',
      savedDate: this._filters$.value.savedDate,
      loadedBookings: [],
      searchTerm: '',
      showEmpty: true,
    };

    //    console.log('Resetting filters ', nextState);
    this._filters$.next(nextState);
  }
}
